export default {

    urlDomain: 'https://appjustable.com',

    titleBackground: '#fff',
    titleBorder: '#ddd',
    bodyBackground: '#fff',
    overlayColor: 'rgba(0,0,0,.4)',
    lightBoxWidth: 500,
    
    useTitle: true,
    closeIconColor: '#aaa',
    useShadow: true

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/lightboxsettings.js